import { render, staticRenderFns } from "./BindUserGroup.vue?vue&type=template&id=fae50292&scoped=true"
import script from "./BindUserGroup.vue?vue&type=script&lang=js"
export * from "./BindUserGroup.vue?vue&type=script&lang=js"
import style0 from "./BindUserGroup.vue?vue&type=style&index=0&id=fae50292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae50292",
  null
  
)

export default component.exports